import ToolTip from "../../ToolTip/ToolTip";

export const Tutor_Replace_Leads_Head = [
  { field: "slNo", headerName: "Sl No", width: 80 },
  { field: "leadName", headerName: "Student Name", width: 200 },
  {
    field: "courseName",
    headerName: "Course Name",
    width: 250,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.courseName}
          expand={params.row.courseName}
        />
      );
    },
  },
  {
    field: "subjectName",
    headerName: "Subject Name",
    width: 200,
  },
  { field: "croName", headerName: "CRO Name", width: 200 },
  { field: "oldTrainerName", headerName: "Old Tutor Name", width: 200 },
  {
    field: "newTrainerName",
    headerName: "New Tutor Name",
    width: 200,
  },
  {
    field: "trainer_unmap_reason",
    headerName: "Reason of replacement",
    width: 200,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.trainer_unmap_reason}
          content={params.row.trainer_unmap_reason}
        />
      );
    },
  },
  {
    field: "replacement_timestamp",
    headerName: "Replaced Date",
    width: 200,
    renderCell: (params) => {
      return new Date(params.row.replacement_timestamp).toDateString();
    },
  },
];
